import { render, staticRenderFns } from "./CreateArticles.vue?vue&type=template&id=37f4cccf&scoped=true"
import script from "./CreateArticles.vue?vue&type=script&lang=js"
export * from "./CreateArticles.vue?vue&type=script&lang=js"
import style0 from "./CreateArticles.vue?vue&type=style&index=0&id=37f4cccf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f4cccf",
  null
  
)

export default component.exports